import ProtectedRoute from "@/navigation/ProtectedRoute";
import UnprotectedRoute from "@/navigation/UnprotectedRoute";
import { ReactNode } from "react";

interface IProps {
  protection?: "protected" | "unprotected" | "public";
  children: ReactNode;
}

const AppMiddleware = ({ protection = "protected", children }: IProps) => {
  const protectionComponentOptions = {
    protected: ProtectedRoute,
    unprotected: UnprotectedRoute,
    public: "div",
  };

  const ProtectionComponent = protectionComponentOptions[protection];

  return <ProtectionComponent>{children}</ProtectionComponent>;
};

export default AppMiddleware;
